import firebase from 'firebase/compat/app';
import { AuditTemplate } from './types';

const getCollection = (orgId: string) =>
  firebase.firestore().collection(`orgs/${orgId}/auditTemplates`);

export const fetchTemplatesForMachine = async (
  orgId: string,
  machineId: string
): Promise<AuditTemplate[]> => {
  const snapshot = await getCollection(orgId)
    .where('machineIds', 'array-contains', machineId)
    .get();

  return snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() } as AuditTemplate));
};

export const linkMachineToTemplate = async (
  orgId: string,
  templateId: string,
  machineId: string
): Promise<void> => {
  return getCollection(orgId)
    .doc(templateId)
    .update({
      machineIds: firebase.firestore.FieldValue.arrayUnion(machineId),
    });
};

export const unlinkMachineFromTemplate = async (
  orgId: string,
  templateId: string,
  machineId: string
): Promise<void> => {
  return getCollection(orgId)
    .doc(templateId)
    .update({
      machineIds: firebase.firestore.FieldValue.arrayRemove(machineId),
    });
};
